import queryString from 'query-string';
import CategorizeVideo from 'src/adminPanel/entities/it/videos/CategorizeVideo';
import NewVideoRequest from 'src/adminPanel/entities/it/videos/NewVideoRequest';
import VideoRatingFilter from 'src/adminPanel/entities/it/videos/VideoRatingFilter';
import { generateRequestHeadersPageable } from 'src/adminPanel/utils/helperClasses';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

/* Video Topics */
export const fetchVideoTopicsAdmin = (): Promise<CallApiResult> => {
    return callApi('/api/video/admin/videoTopics');
};

/* Video Categories by topicId */
export const fetchVideoCategoriesByTopicIdAdmin = (topicId: string): Promise<CallApiResult> => {
    return callApi('/api/video/admin/videoCategories/' + topicId);
};

/* Fetch Videos */
export const fetchVideosAdmin = () => {
    const endpoint = '/api/video/admin/list';
    return callApi(endpoint);
};

/* Fetch Videos By VideoCategoryId */
export const fetchVideosByVideoCategoryIdAdmin = (videoCategoryId: string) => {
    const endpoint = '/api/video/admin/list/' + videoCategoryId;
    return callApi(endpoint);
};

/* Insert new Video */
export const submitInsertVideoAdmin = (newVideo: NewVideoRequest) => {
    const endpoint = '/api/video/admin/insertVideo';
    return callApi(endpoint, { method: 'POST', data: newVideo });
};

/* Edit Video */
export const editVideoAdmin = (editedVideo: NewVideoRequest) => {
    const endpoint = '/api/video/admin/editVideo';
    return callApi(endpoint, { method: 'PUT', data: editedVideo });
};

/* Upload Video */
export const submitUploadVideoAdmin = (videoId: string, languageIso2: string, videoFile: any) => {
    const formData = new FormData();
    formData.append('file', videoFile);

    const endpoint = `/api/video/admin/uploadVideo/${videoId}/${languageIso2}`;
    return callApi(endpoint, { method: 'POST', data: formData });
};

/* Remove Video */
export const removeVideoAdmin = (videoLanguageId: string) => {
    const endpoint = '/api/video/admin/removeVideo/' + videoLanguageId;
    return callApi(endpoint, { method: 'DELETE' });
};

/* Fetch VideoCategories */
export const fetchVideoCategoriesAdmin = () => {
    const endpoint = '/api/video/admin/videoCategories';
    return callApi(endpoint);
};

/* Categorized Video */
export const submitCategorizeVideoAdmin = (categorizeVideo: CategorizeVideo) => {
    const endpoint = '/api/video/admin/categorizeVideo';
    return callApi(endpoint, { method: 'POST', data: categorizeVideo });
};

/* remove Video Category */
export const removeVideoCategoryAdmin = (videoVideoCategoryId: string) => {
    const endpoint = '/api/video/admin/removeVideoCategory/' + videoVideoCategoryId;
    return callApi(endpoint, { method: 'DELETE' });
};

/* Fetch Video Ratings */
export const fetchVideoRatingsAdmin = (
    videoId: string,
    filter: VideoRatingFilter,
    pageable: PageableQueryParams = {}
) => {
    let query = queryString.stringify({ ...filter }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/video/admin/videoRatings/${videoId}${query}`;
    return callApi(endpoint, { method: 'GET', headers: generateRequestHeadersPageable(pageable) });
};
